<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2233_49262)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 4.5C2.91015 4.5 0 7.41015 0 11C0 14.5899 2.91015 17.5 6.5 17.5H15.5C19.0899 17.5 22 14.5899 22 11C22 7.41015 19.0898 4.5 15.5 4.5H6.5ZM6.5 7.09277C4.3421 7.09277 2.59277 8.8421 2.59277 11C2.59277 13.1579 4.3421 14.9072 6.5 14.9072C8.6579 14.9072 10.4072 13.1579 10.4072 11C10.4072 8.8421 8.6579 7.09277 6.5 7.09277Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2233_49262">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
